export const pyroFormValidator = <T>(
  validate: (values: T) => Partial<{ [K in keyof T]: string }>,
): ((values: T) => Partial<{ [K in keyof T]: string }>) => {
  return (values: T) => validate(values) || {}
}
